import { clstx } from '@payaca/utilities/cvaMerge';
import { ComponentPropsWithoutRef, forwardRef, useContext, useId } from 'react';
import { FieldContext } from '../Field/Context';
import UntitledLoading from '../UntitledLoading/UntitledLoading';

export interface CheckboxProps extends Omit<
  ComponentPropsWithoutRef<'input'>,
  'type' | 'id' | 'name'
> {
  hiddenLabel?: boolean;
  label?: string;
  isProcessing?: boolean;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const {
    className,
    hiddenLabel = false,
    isProcessing = false,
    disabled,
    label,
    ...rest
  } = props;
  const { id, name, validationState } = useContext(FieldContext);
  const generatedId = useId();
  const uId = id || generatedId;

  return (
    <div className="typography:prose flex">
      {isProcessing && (
        <UntitledLoading
          className={clstx('h-4 w-4', !!label && 'mt-[.44rem]')}
        />
      )}
      <input
        ref={ref}
        id={uId}
        name={name}
        className={clstx(
          'pl-form-checkbox',
          className,
          isProcessing && 'hidden',
          disabled ? 'cursor-not-allowed' : 'cursor-pointer',
          !!label && 'mt-[.44rem]'
        )}
        type="checkbox"
        disabled={disabled}
        {...rest}
      />
      {label && (
        <label
          htmlFor={uId}
          className={
            'ms-3' +
            (hiddenLabel ? ' sr-only' : '') +
            (disabled ? ' cursor-not-allowed' : ' cursor-pointer')
          }
        >
          {label}
        </label>
      )}
    </div>
  );
});

export default Checkbox;
